import React from "react";

import { ReportsIndex } from "../user";

export default function Detail(props) {
  return <ReportsIndex isAdmin {...props} />;
}
